module.exports = __webpack_public_path__ + "img/Leanplum.dc74324f.jpg";